import { useMediaQuery } from '@material-ui/core'
import { Theme as MuiTheme, ThemeOptions as MuiThemeOptions } from '@material-ui/core/styles'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'
import { Palette } from '@material-ui/core/styles/createPalette'
import { Typography } from '@material-ui/core/styles/createTypography'

import { CustomColorTypes, CustomFontWeightTypes } from './CustomThemeTypes'

interface CustomTheme extends MuiTheme {
  palette: Palette & CustomColorTypes
  typography: Typography & CustomFontWeightTypes
}

interface CustomThemeOptions extends MuiThemeOptions {
  palette: Palette & CustomColorTypes
  typography: Typography & CustomFontWeightTypes
}

export type ThemeOptions = CustomThemeOptions
export type Theme = CustomTheme

export type Sizes = Partial<Record<Breakpoint, number>> & { xs: number }

export const sizeFor = (sizes: Sizes, { breakpoints }: Theme): number => {
  return breakpoints.keys.reduce((acc, key) => {
    const size = sizes[key]
    if (!size) return acc

    if (useMediaQuery<Theme>(breakpoints.up(key))) {
      return size
    }

    return acc
  }, sizes.xs)
}

export const remSizeFor = (sizes: Sizes, theme: Theme) =>
  sizeFor(sizes, theme) * theme.typography.fontSize
